module.exports = __webpack_public_path__ + "71148ccaf40f397c64c570485ce122cf.png";